export default {
  title: 'Help en veelgestelde vragen',
  buttons: {
    faqs: "FAQ'S",
    contact_us: 'Contact',
  },
};
